$(document).ready(function(){

  Fancybox.bind('[data-fancybox]', {
    Toolbar: {
      display: ["counter", "zoom", "slideshow", "fullscreen", "close"]
    },
    Thumbs: {
      autoStart: false,
    },
  });

});